// +----------------------------------------------------------------------
// | Desc: 全局config配置信息库
// +----------------------------------------------------------------------
const config = {
  // api: "http://wzd.com", //api基础路由
  // img: "http://wzd.com", //img连接基础路由
  // h5: "http://wzd.com", //前端访问
  api: "https://api.wzdip.com", //api基础路由
  img: "https://api.wzdip.com", //img连接基础路由
  h5: "https://wzdip.com", //前端访问
};
export default config;
